import equitasLogo from './logo_equitas.png'
import './App.css'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={equitasLogo} className="App-logo" alt="logo" />
        <p>
          The Equitas App is currently undergoing planned maintenance
        </p>
        <p>
          From Friday 15th May 8pm to Monday 18th May 5am (GMT time)
        </p>
        <p>
          <strong>Please do not access the app until after 5am on Monday 18th May</strong>
        </p>
        <p>
          Thank you for your understanding
        </p>
      </header>
    </div>
  );
}

export default App;
